export type EligibilityTab =
  | "eligibility-status"
  | "missing-services"
  | "open-statements"
  | "ledger";

export const ELIGIBILITY_TABS: readonly EligibilityTab[] = [
  "eligibility-status",
  "missing-services",
  "open-statements",
  "ledger",
];

/** Tabs only Biller, Manager, and Provider Admin may open. */
export const BILLER_MANAGER_ELIGIBILITY_TABS: readonly EligibilityTab[] = [
  "missing-services",
  "ledger",
];
